import React from "react";
import { Avatar } from "@fluentui/react-northstar";
import PropTypes from "prop-types";
import { CallIcon } from "@fluentui/react-icons-northstar";

const GreyCallIconAvatar = (props) => {
  const { size } = props;

  return (
    <Avatar
      data-testid="greyCallIconAvatar"
      className="grey-call-icon-avatar"
      icon={<CallIcon />}
      size={size}
    />
  );
};

GreyCallIconAvatar.propTypes = {
  size: PropTypes.string,
};

GreyCallIconAvatar.defaultProps = {
  size: "medium",
};

export default GreyCallIconAvatar;
